export const ConsumerSubmitConsentUat = {
  consentCheckbox: 'workflow.consumerSubmit.consentCheckbox',
  viewConsentLink: 'workflow.consumerSubmit.viewConsentLink',
}
